module.exports = __webpack_public_path__ + "media/images/writer/reservation/logo-maker-3c1faa102cbbcdf6e0727b7f524bb74b.svg";